import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie';
import { ErrorsService } from '../errors/errors.service';
import { Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { IRootState, selectLanguage } from '@app/store';
import { toSignal } from '@angular/core/rxjs-interop';

export function authInterceptorFactory(
  cookieService: CookieService,
  errorsService: ErrorsService,
  injector: Injector,
  store: Store<IRootState>,
): HttpInterceptor {
  // public URLs
  const PUBLIC_URLS = ['login', 'restore_password', 'verify', 'register', 'spheres'];

  const currentLang = toSignal(store.select(selectLanguage));

  return {
    intercept: (req: HttpRequest<any>, next: HttpHandler): Observable<any> => {
      // const translateService = injector.get(TranslateService);
      const token = cookieService.get('token');
      let headers = req.headers;

      headers = headers.set('Accept-Language', currentLang() as string);

      const isPublic = PUBLIC_URLS.some((url) => req.url.includes(url));

      if (!isPublic && token) {
        headers = headers.set('Authorization', token);
      }

      const clonedReq = req.clone({ headers });

      const isAnalytics = req.url.includes('analytics.');

      return next.handle(clonedReq).pipe(
        catchError((err: HttpErrorResponse) => {
          console.log('intercept error:', err);

          // analytics-модуль обрабатывает ошибки сам (показывает inline-сообщение в контейнере),
          // глобальный popup для него отключаем — иначе пользователь видит «0 Сообщение: true»
          // на каждой не-авторизованной странице analytics.
          if (!isAnalytics) {
            // 403 (нет прав по ролевой модели) тихо проглатываем: ни модалки, ни тоста —
            // для read-only ролей запрет ожидаем, UI сам прячет/дизейблит действия.
            if (err.status === 403) {
              return EMPTY;
            }
            errorsService.openPopup(err);
          }

          return throwError(() => err);
        }),
      );
    },
  };
}
